const DetailIcon = (props) => {
    return <i className={"fa-solid fa-circle-info " + props.className}></i>
}

export default DetailIcon;